import styled, { css } from 'styled-components';

import { Price, breakpoints, theme } from '@notino/react-styleguide-v20';

import { Slash } from '@sharedComponents/Separators';

import { IPriceModel, ISeparatorModel } from './model';

interface ICheckoutWrapperProps {
  isColumnLayout: boolean;
}

export const StyledCheckoutPriceWrapper = styled.div<ICheckoutWrapperProps>`
  display: flex;
  flex-direction: ${({ isColumnLayout }) => (isColumnLayout ? 'column' : 'row')};
  align-items: flex-end;
`;

export const StyledPrice = styled(Price)<
  Pick<IPriceModel, 'bold' | 'isHighLighted' | 'isOldPrice' | 'isActive' | 'showSeparatorInColumn' | 'priceSize'>
>`
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
  color: ${({ isHighLighted, isOldPrice, isActive }) => {
    if (!isActive) return;
    const colorByOldPrice = isOldPrice ? theme.color.text.tertiary : theme.color.text.primary;
    return isHighLighted ? theme.color.text.highlight : colorByOldPrice;
  }};
  text-decoration: ${({ isOldPrice }) => (isOldPrice ? 'line-through;' : 'none')};

  @media (max-width: ${breakpoints.sm}) {
    font-weight: ${({ isOldPrice }) => (isOldPrice ? 'normal' : 'bold')};
  }

  ${({ showSeparatorInColumn, priceSize }) =>
    showSeparatorInColumn &&
    css`
      display: inline-block;
      &::after {
        content: '\\00a0/\\00a0';
        font-size: ${priceSize};
        vertical-align: bottom;
      }
    `}
`;

interface ISlashProps extends ISeparatorModel {
  visible: boolean;
}

export const StyledSlash = styled(Slash)<ISlashProps>`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  font-size: ${({ separatorSize }) => separatorSize};
  font-weight: ${({ bold }) => (bold ? 'bold' : 'normal')};
`;
